import React from 'react';
import cn from 'classnames';
import EllipsisTextWithTooltip from '../../../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import styles from './index.module.scss';

const PanelHeader = ({ title, subtitle, meta, actionsSlot, onTitleClick }) => {
  return (
    <article className={styles.root}>
      <div className={styles.heading}>
        <EllipsisTextWithTooltip
          as="h4"
          className={cn(styles.title, {
            [styles.clickable]: typeof onTitleClick === 'function',
          })}
          tooltipTitle={title}
          onClick={onTitleClick}
        >
          {title}
        </EllipsisTextWithTooltip>
        <div className={styles.actionsSlot}>{actionsSlot}</div>
      </div>
      <div className={styles.descWrap}>
        <p className={styles.text} data-color="black">
          {subtitle}
        </p>
        {meta ? (
          <p className={styles.text} data-color="blue">
            {meta}
          </p>
        ) : null}
      </div>
    </article>
  );
};

export default PanelHeader;
